import moment from 'moment';
// Grid formatters - START

const dateFormat = 'MMM DD hh:mm:ss A';

// TODO: Set this to the language set by the user, when in the future we give the user the option to do that
// TODO: Turn currencyFormatter into a function which checks for undefined
export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
});

export const costCurrencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 3
});

const longFormatter = new Intl.NumberFormat();

const numberFormatter = value => {
  if (typeof value === 'undefined') {
    return '';
  }
  
  if (isNaN(value) || (value.indexOf && value.indexOf('+') > -1)) {
    return value;
  }

  return longFormatter.format(value);
};

export const booleanFormatter = value => {
  if (value === 0 || value === false) {
    return 'No';
  } else if (value === 1 || value === true) {
    return 'Yes';
  }

  return numberFormatter(value);
};

const percentFormatter = numberFormatter;
const timespanFormatter = numberFormatter;
// Grid formatters - END

export function isWhitespace(value) {
  return /^\s*$/.test(value);
}

export const columnTypes = {
  keyword: {},
  double: {
    valueFormatter: ({ value }) => {
      if (typeof value !== 'undefined' && value !== '') {
        return currencyFormatter.format(value);
      }
      
      return '';
    },
    headerClass: 'ag-right-aligned-header'
  },
  money: {
    valueFormatter: ({ value }) => {
      if (typeof value !== 'undefined' && value !== '') {
        return currencyFormatter.format(value);
      }
      
      return '';
    },
    headerClass: 'ag-right-aligned-header'
  },
  long: {
    valueFormatter: ({ value }) => {
      if (typeof value === 'undefined') {
        return '';
      }

      return longFormatter.format(value);
    },
    headerClass: 'ag-right-aligned-header'
  },
  percent: {
    valueFormatter: ({ value }) => percentFormatter(value),
    headerClass: 'ag-right-aligned-header',
    comparator(valueA, valueB) {
      return parseInt(valueA) - parseInt(valueB);
    }
  },
  integer: {
    valueFormatter: ({ value }) => longFormatter.format(value),
    comparator(valueA, valueB) {
      return parseInt(valueA) - parseInt(valueB);
    }
  },
  tag: {
    headerClass: 'ag-right-aligned-header',
    valueFormatter: (params) => {
      const value = params.value;
      if (value?.length && isWhitespace(value)) {
        return '—'.repeat(value.length);
      }
      return value;
    }
  },
  boolean: {
    valueFormatter: ({ value }) => booleanFormatter(value),
    headerClass: 'ag-right-aligned-header'
  },
  timespan: {
    valueFormatter: ({ value }) => timespanFormatter(value),
    headerClass: 'ag-right-aligned-header'
  },
  date: {},
  groupByDate: {
    valueFormatter: ({ value }) => {
      if (typeof value === 'undefined') {
        return '';
      }

      const dateParts = value?.split('T');
      return dateParts?.length > 0 ? dateParts[0] : '';
    }
  }
};

export const numericTypes = {
  double: true,
  money: true,
  long: true,
  percent: true,
  tag: true,
  boolean: true,
  timespan: true,
  integer: true,
};

export const numericTypesForCallLogSummary = {
  ...numericTypes,
  tag: false,
};

export const numericTypesForCallLogs = {
  ...numericTypes,
  boolean: false
};

export const eventFieldFormatters = {
  currency: function format(value) {
    return currencyFormatter.format(value);
  },
  date: function format(value, timeZoneId) {
    if (timeZoneId) {
      return moment.utc(value).tz(timeZoneId).format(dateFormat);
    }

    return moment(value).format(dateFormat);
  },
  seconds: function format(value) {
    return `${moment.utc(value * 1000).format('HH:mm:ss')}`;
  },
  bool: function formatBool(value) {
    return value ? 'Yes' : 'No';
  }
};

export function handleDocumentClickListenerToCloseToolPanel(gridApi) {
  return function handleDocumentClick(ev, ignoreElement) {
    if (gridApi.isToolPanelShowing()) {
      const sideBarButtonsElement = gridApi.gridCore.eGui.querySelector('div[ref="sideBar"]');
      const path = ev.path || (ev.composedPath ? ev.composedPath() : undefined);

      if (path
        ? (path.indexOf(sideBarButtonsElement) < 0 && (!ignoreElement || path.indexOf(ignoreElement) < 0))
        : (!sideBarButtonsElement.contains(ev.target) && (!ignoreElement || ignoreElement.contains(ev.target)))) {
        gridApi.closeToolPanel();
      }
    }

  };
}

// TODO: Remove this in the next release after upgrade has been pushed
export function combineSortModelToColumnStateForNewAgGrid(sortModel, columnState) {
  if (sortModel?.length && columnState) {
    sortModel.forEach((col, idx) => {
      const column = columnState.find(colB => col.colId === colB.colId);

      column.sort = col.sort;
      column.sortIndex = idx;
    });
  }

  return columnState;
}